"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
function listNotifications({ workspaceId, limit, cursor, filter, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        endpoint: `?${(0, querystring_1.stringify)({ limit, cursor, filter })}`,
        workspaceId,
    });
}
function getNotification({ workspaceId, notificationId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        endpoint: notificationId,
        workspaceId,
    });
}
function readNotification({ workspaceId, notificationId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        method: 'PATCH',
        endpoint: notificationId,
        body: { op: 'read' },
        workspaceId,
    });
}
function readAllNotifications({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        method: 'PATCH',
        body: { op: 'read' },
        workspaceId,
    });
}
function getNotificationSummary({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        endpoint: 'summary',
        workspaceId,
    });
}
function resetNotificationSummary({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.notifications, {
        method: 'DELETE',
        endpoint: 'summary',
        workspaceId,
    });
}
exports.Notifications = {
    listNotifications,
    getNotification,
    readNotification,
    readAllNotifications,
    getNotificationSummary,
    resetNotificationSummary,
};
//# sourceMappingURL=notifications.js.map